import { render, staticRenderFns } from "./VideoGallery.vue?vue&type=template&id=cd8c61da&"
import script from "./VideoGallery.vue?vue&type=script&lang=js&"
export * from "./VideoGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd8c61da')) {
      api.createRecord('cd8c61da', component.options)
    } else {
      api.reload('cd8c61da', component.options)
    }
    module.hot.accept("./VideoGallery.vue?vue&type=template&id=cd8c61da&", function () {
      api.rerender('cd8c61da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/gallery/VideoGallery.vue"
export default component.exports